module.exports = __webpack_public_path__ + "img/winner-tech-innovation-awards-icon.f9281972.png";